export const removeUndefinedValuesFromObject = (rawPayload: Record<string, any>) => {
  Object.entries(rawPayload).forEach(([key, value]) => {
    if (value === undefined) {
      delete (rawPayload)[key];
    }
  });
};